import axiosLib from 'axios';
import createAxios from 'dashboard/helper/APIHelper';

let cachedAxios = null;

const normalizeAxios = lib => (lib && lib.default ? lib.default : lib);

const isAxiosLike = instance =>
  instance &&
  (typeof instance === 'function' || typeof instance === 'object') &&
  typeof instance.get === 'function' &&
  typeof instance.post === 'function';

const safeSetWindowAxios = instance => {
  try {
    if (typeof window !== 'undefined') window.axios = instance;
  } catch (e) {
    // best-effort
  }
};

export default function getWootAxios() {
  const axiosBase = normalizeAxios(axiosLib);

  // Non-browser environments (tests/SSR): fall back to axios lib
  if (typeof window === 'undefined') {
    if (isAxiosLike(cachedAxios)) return cachedAxios;
    cachedAxios = isAxiosLike(axiosBase) ? axiosBase : cachedAxios;
    return cachedAxios;
  }

  if (isAxiosLike(window.axios)) return window.axios;
  if (isAxiosLike(cachedAxios)) return cachedAxios;

  let instance = null;
  try {
    instance = createAxios(axiosBase);
  } catch (e) {
    instance = null;
  }

  if (!isAxiosLike(instance)) {
    instance = isAxiosLike(axiosBase) ? axiosBase : window.axios;
  }

  cachedAxios = instance;
  safeSetWindowAxios(instance);
  try {
    globalThis.axios = instance;
  } catch (e) {
    // best-effort
  }
  return instance;
}
